import { render, staticRenderFns } from "./CheckoutThankYouNew.vue?vue&type=template&id=0407f946&"
import script from "./CheckoutThankYouNew.vue?vue&type=script&lang=js&"
export * from "./CheckoutThankYouNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports